export enum MemberType {
  A = 1,  // フリー(ID/PW無し)
  B = 2,  // 無料会員(ID/PW発行)
  C = 3,  // 有料会員(ID/PW発行)
}